import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DriveFolder } from '../models/DriveFolder';

export interface IDocumentManager {
    getUserRolesName?(roles: string[]): Observable<any>;
    getPersonsDisplayName?(objectArtifact: any): Observable<any>;
}

export interface IDmsConfig {
    RowBreakPoint?: Object;
    folderNameMinLength?: number;
    hideSideNav?: boolean;
    viewConfig?: {
        listView: boolean;
    };
    ExtMap?: { [key: string]: { IconName: string } };
    menuItems?: IMenuItems[];
    detailsTab?: IDetailsTabConfig;
    maxFileSize?: number;
    OrganizationId?: string;
    AdditionalIconButtons?: TemplateRef<any>;
    UseLicensing?: boolean;
    downloadSecureFile?: boolean;
    hideFileSize?: boolean;

    rootRoute:string;
    initialBreadcumb:any;
    viewMyDoc:boolean;
    viewSharedDoc:boolean;
    viewArchivedDoc:boolean;
    zipDownloadFileName:string;
    BreadcrumbName:string;
    ModuleWorkspaceId:string;
    ParentFolderId:string;
    Search:boolean;
    actionOnShared: boolean;
    moduleFeatureId:string;
    features:{
        addDoc:any[],
        deleteDoc: any[],
        shareDoc:any[],
    },
    updateAccessRoles:object;
    shareToUserIds?:string[];
    disableModificationInRootFolder?:boolean;
    useCustomApi?: boolean,
    useMAAPPView?: boolean,
    myDocumentsView?: boolean
}

export interface IDetailsTabConfig {
    isShowRoles?: boolean;
    isShowPersons?: boolean;
    rolesList?: IRolesMap[];
    dynamicRoleCallback?: boolean;
    dynamicPersonsCallback?: boolean;
    showAccessType?: boolean;
}

interface IMenuItems {
    icon: string;
    text: string;
    callEvent?: object | void;
}

interface IRolesMap {
    Value: string;
    ViewValue: string;
}

export interface ISharedPerson {
    ColorCode?: string;
    TextColorCode?: string;
    DisplayName: string;
    ItemId: string;
    ProfileImage?: string;
    Roles?: string[];
}
